import { createSagaAction } from 'saga-toolkit';

export const actions = {
	EXPORT: 'EXPORT'
};

export const exportReport = createSagaAction(actions.EXPORT);